import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MemberRowSelectorComponent } from './member-row-selector.component';
import { MembersService } from '../../../../services/members/members.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../../shared/shared.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { CreateOwnerModule } from '../../../shared/create-owner/create-owner.module';

@NgModule({
    imports: [
        CommonModule,
        CreateOwnerModule,
        FlexLayoutModule,
        ModalModule,
        SharedModule,
        MatIconModule,
    ],
    declarations: [MemberRowSelectorComponent],
    exports: [MemberRowSelectorComponent],
    providers: [
        MembersService,
    ],
})
export class MemberRowSelectorModule
{
}
